import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PointsCard from '../components/PointsCard';
import OffersList from '../components/OffersList';
import MapSection from '../components/MapSection';
import FeatureSection from '../components/FeatureSection';
import HeroSection from '../components/HeroSection';

const HomePage: React.FC = () => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: 1, y: 0 });
  }, [controls]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#007BFF] via-[#40E0D0] to-[#00C9FF] text-white">
      <Header />
      
      <main className="container mx-auto px-4 pt-16 pb-24">
        <HeroSection />
        
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={controls}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="mt-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
            Votre fidélité <span className="text-[#7B1FA2]">récompensée</span> dans votre poche
          </h2>

          <PointsCard />
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12">
            <FeatureSection />
            <MapSection />
          </div>

          <section className="mt-16">
            <h2 className="text-3xl font-bold mb-8 text-center">Offres Promotionnelles</h2>
            <OffersList />
          </section>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
